import { render, staticRenderFns } from "./GroupFormPageSCT.vue?vue&type=template&id=1217bc2e&scoped=true&"
import script from "./GroupFormPageSCT.vue?vue&type=script&lang=js&"
export * from "./GroupFormPageSCT.vue?vue&type=script&lang=js&"
import style0 from "./GroupFormPageSCT.vue?vue&type=style&index=0&id=1217bc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217bc2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1217bc2e')) {
      api.createRecord('1217bc2e', component.options)
    } else {
      api.reload('1217bc2e', component.options)
    }
    module.hot.accept("./GroupFormPageSCT.vue?vue&type=template&id=1217bc2e&scoped=true&", function () {
      api.rerender('1217bc2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/GroupFormPageSCT.vue"
export default component.exports